import React from 'react';
import PropTypes from 'prop-types';
import PouRastitelno from './PouRastitelno';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Notification from '../../../common/Notification';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {cleanJsonBody} from "../../../redux/helpers";
import {getPouRastitelno} from "../../../redux/pouRastitelno/reducer";
import {createPouRastitelnoRequest, fetchNewPouRastitelno} from "../../../redux/pouRastitelno/fetch";
import {getUploadedFile} from "../../../redux/fileSystem/reducer";
import {uploadFileRequest} from "../../../redux/fileSystem/fetch";
import {getUser} from "../../../redux/user/reducer";
import {fetchLookupByType, fetchLookups} from "../../../redux/lookup/fetch";
import {getLookupMap} from "../../../redux/lookup/reducer";
export class CreatePouRastitelno extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.savePouRastitelno = this.savePouRastitelno.bind(this);
        this.uploadFileRastitelno = this.uploadFileRastitelno.bind(this);
        this.redirectToPouRastitelnoList = this.redirectToPouRastitelnoList.bind(this);
        this.state = {notify: false, message: '', error: false};
    }

    componentWillMount() {
        const {fetchNewPouRastitelno, fetchLookups} = this.props;
        fetchNewPouRastitelno();
        fetchLookups();
    }

    savePouRastitelno(values) {
        /*  Create and call updatePouRastitelno action */
        let newValues = cleanJsonBody(JSON.parse(JSON.stringify(values)), true);
        this.props.createPouRastitelnoRequest(newValues)
        this.showNotification("Успешно креирано ПОУ растително!");
        setTimeout(() => this.redirectToPouRastitelnoList(), 1000); //execute greet after 2000 milliseconds (2 seconds)
    }

    uploadFileRastitelno(file) {
        // this.props.uploadFileRequest(file)
        // this.showNotification("Успешно прикачен фајл");
        const myInput = document.getElementById(file);
        return uploadFileRequest(myInput).then(res => {
            this.showNotification("Успешно прикачен фајл!");
            return res
        })
    }

    redirectToPouRastitelnoList() {
        this.props.history.push(`/PouRastitelnoList`);
    }

    showNotification = (msg, err) => {
        if (err) {
            this.setState({notify: true, message: msg, error: true});
        } else {
            this.setState({notify: true, message: msg, error: false});
        }
        setTimeout(() => this.setState({notify: false, message: "", error: false}), 5000);
    };

    handleNotificationClosed = () => {
        this.setState({
            notify: false
        });
    };

    render() {
        const {notify, message, error} = this.state;
        return (
            <div>
                <Card>
                    <CardContent>
                        <h1>Креирај ПОУ растително</h1>
                    </CardContent>
                    {this.props.pouRastitelno &&
                    <PouRastitelno
                        pouRastitelno={this.props.pouRastitelno.pouRastitelno}
                        createMode
                        uploadFile={this.uploadFileRastitelno}
                        onSubmit={this.savePouRastitelno}
                        onCancel={this.redirectToPouRastitelnoList}
                        user={this.props.user}
                        lookupData={this.props.lookupData}
                    />}
                </Card>

                <Notification
                    notify={notify}
                    message={message}
                    error={error}
                    closed={this.handleNotificationClosed}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        id: id,
        pouRastitelno: getPouRastitelno(state),
        uploadedFileId: getUploadedFile(state),
        user: getUser(state),
        lookupData: getLookupMap(state)
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchNewPouRastitelno,
        createPouRastitelnoRequest,
        uploadFileRequest,
        fetchLookupByType,
        fetchLookups
    }, dispatch)
}

CreatePouRastitelno.propTypes = {
    dispatch: PropTypes.func
};

CreatePouRastitelno.contextTypes = {
    router: PropTypes.object
};
export default connect(mapStateToProps, mapDispatchToProps)(CreatePouRastitelno);